
export function formatarMoedaBrasileira(valor) {
    if (valor) {
        const partes = valor.toFixed(2).split('.');
        partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return partes.join(',');
    } else {
        return "0";
    }

}


export function formatNumero(valor) {
    if (valor) {
        return valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    } else {
        return "0";
    }

}

